<div class="invoice-container">
  <div>
    <p-button label="Export" class="p-button-outlined" (click)="exportData()" icon="pi pi-file-export"
      size="small"></p-button>

  </div><br>
  <table id="pdf-table" class="invoice-table">
    <thead>
      <tr>
        <th>Invoice No</th>
        <th>Invoice Date</th>
        <th>Bill-To Customer</th>
        <th>Product Code</th>
        <th>Product Name</th>
        <th>UOM</th>
        <th>Quantity Shipped</th>
        <th>Sales Tax</th>
        <th>Unit Price</th>
        <th>Amount</th>
        <th>Total Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let product of productTableData">
        <td>{{ product.salesOrderNumber }}</td>
        <td>{{ product.createdDate | date: 'shortDate'}}</td>
        <td>{{ product.customerName }}</td>
        <td>{{ product.productCode }}</td>
        <td>{{ product.productDescription }}</td>
        <td>{{ product.uom }}</td>
        <td>{{ product.shippedQuantity }}</td>
        <td>{{ product.salesTax }}</td>
        <td>{{ product.unitPrice }}</td>
        <td>{{ product.unitPrice * product.shippedQuantity }}</td>
        <td>{{ (product.unitPrice * product.shippedQuantity) + product.salesTax }}</td> <!--created by Nilesh-->
      </tr>
    </tbody>
  </table>
</div>